export default `
"layer 1 here"
"layer 2 here"
"and another one"
`